import { useProjectDefinitionQuery } from 'src/app/projects/views/project-list/state/api/projectListGraphSlice';
import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';
import { AnalyticsOptions } from 'src/shared/helpers/analyticsHelper';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';

const useDashboardAnalytics = () => {
    const { currentProjectSelectedHabitatAssayType, currentProjectId } = useProjectFilters();

    const { currentData: projectDefinition } = useProjectDefinitionQuery({
        projectId: currentProjectId || '',
    });

    const sendTrackEvent = (ga: AnalyticsOptions) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: projectDefinition?.projectName,
            habitatAssayType: currentProjectSelectedHabitatAssayType?.key || '',
            app: AppName.DASHBOARD,
        });
    };

    const trackDateFilterChange = (selectedDates: string) => {
        sendTrackEvent({
            action: 'date_filter_changed',
            category: 'date-filter',
            label: selectedDates,
        });
    };

    const trackSpeciesHighlightViewed = () => {
        sendTrackEvent({
            action: 'species_highlight_viewed',
            category: 'species-highlight',
            non_interaction: true,
        });
    };

    const trackIUCNTableViewed = () => {
        sendTrackEvent({
            action: 'iucn_table_viewed',
            category: 'iucn_table',
            non_interaction: true,
        });
    };

    const trackUpgradeSubscriptionClick = () => {
        sendTrackEvent({
            action: 'upgrade_subscription_click_from_dashboard',
            category: 'upgrade-subscription-link',
        });
    };

    return {
        trackDateFilterChange,
        trackSpeciesHighlightViewed,
        trackIUCNTableViewed,
        trackUpgradeSubscriptionClick,
    };
};

export default useDashboardAnalytics;
